import React from 'react';
import { GlobalFilterState } from './GlobalFilterState';
import { GroupedDatePickerRange } from './GroupedDatePickerRange';
import { useGroupedDateGlobalFilter } from './useGroupedDateGlobalFilter';

interface GroupedDateGlobalFilterProps {
  dateFiltersState: GlobalFilterState[];
}

export const GroupedDateGlobalFilter: React.FC<GroupedDateGlobalFilterProps> = props => {
  const { dateFiltersState } = props;
  const filterState = useGroupedDateGlobalFilter({ dateFiltersState });

  if (!filterState.fieldSelected) {
    return <></>;
  }

  return (
    <div className="dateTimeRangeFilter">
      <GroupedDatePickerRange
        dateFiltersState={dateFiltersState}
        fieldSelected={filterState.fieldSelected}
        fieldDisplayName={filterState.fieldDisplayName}
        translate={filterState.translate}
        currentValueStart={filterState.currentValueStart}
        currentValueEnd={filterState.currentValueEnd}
        todayEndOfTheDay={filterState.todayEndOfTheDay}
        startPickerOpen={filterState.startPickerOpen}
        endPickerOpen={filterState.endPickerOpen}
        handleFieldChange={filterState.handleFieldChange}
        handleChange={filterState.handleChange}
        handlePopupOpen={filterState.handlePopupOpen}
        handlePopupClose={filterState.handlePopupClose}
        dateTimeStartRef={filterState.dateTimeStartRef}
        dateTimeEndRef={filterState.dateTimeEndRef}
        dateStartRef={filterState.dateStartRef}
        dateEndRef={filterState.dateEndRef}
      />
    </div>
  );
};
